import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import "./TransactionCustomerTable.scss";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";

export default function TransactionCustomerTable({ transferHistory }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(2);
  let pageCount = Math.ceil(transferHistory.length / rowsPerPage);
  let pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <div className="customer-treasury-table-container">
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                colSpan={1}
                className="batch-table-headers grey-background"
              >
                Client
              </TableCell>
              <TableCell
                align="left"
                colSpan={1}
                className="batch-table-headers grey-background"
                // style={{ minWidth: 225 }}
              >
                Balance as of YYYY-MM-DD
              </TableCell>
              <TableCell
                colSpan={3}
                align="center"
                className="batch-table-headers deposit-background"
              >
                Deposits
              </TableCell>
              <TableCell
                colSpan={2}
                align="center"
                className="batch-table-headers transfer-background"
              >
                Payments
              </TableCell>
              <TableCell
                colSpan={2}
                align="center"
                className="batch-table-headers grey-background"
              >
                Trades-Confirmed
              </TableCell>
              <TableCell
                colSpan={2}
                align="center"
                className="batch-table-headers dark-grey-background"
              >
                Trades-Pending
              </TableCell>
              <TableCell
                colSpan={2}
                align="center"
                className="batch-table-headers deposit-background"
              >
                Revenue
              </TableCell>
              <TableCell
                colSpan={1}
                align="center"
                className="batch-table-headers grey-background"
              >
                Including Pending
              </TableCell>
              <TableCell
                colSpan={1}
                align="center"
                className="batch-table-headers grey-background"
              >
                Including Pending+Processing
              </TableCell>
              <TableCell
                colSpan={1}
                align="center"
                className="batch-table-headers grey-background"
              >
                Only Confirmed
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                align="left"
                className="batch-table-headers"
              ></TableCell>
              <TableCell
                align="left"
                className="batch-table-headers"
              ></TableCell>
              <TableCell align="left" className="batch-table-headers">
                Pending
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Processing
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Confirmed
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Pending
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Confirmed
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Trade In
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Trade Out
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Trade In
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Trade Out
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Pending
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Confirmed
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Closing Balance
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Closing Balance
              </TableCell>
              <TableCell align="left" className="batch-table-headers">
                Closing Balance
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transferHistory
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="left" className="batch-row-text">
                    {row.client}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.date}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.depositsPending}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.depositsProcessing}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.depositsConfirmed}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.paymentsPending}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.paymentsConfirmed}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.confirmedTradeIn}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.confirmedTradeOut}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.pendingTradeIn}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.pendingTradeOut}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.revenuePending}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.revenueConfirmed}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.pendingClosing}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.pendingProcessing}
                  </TableCell>
                  <TableCell align="left" className="batch-row-text">
                    {row.confirmedClosing}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="pagination-styling-batch">
        <BaseCustomerTable
          page={page}
          onPageChange={handleChangePage}
          pageNumbers={pageNumbers}
        />
      </div>
    </div>
  );
}
